import React, { useRef, useEffect, useState } from "react";
import useHttp from "../../../hooks/use-http";
import Modal from "react-modal";
import { toast } from "react-toastify";
import Select from "react-select";
import moment from "moment";
import {
  unitConstModel,
  productTypeConstModel,
} from "../../../constant/ConstantList";

const MediaRegistrationForm = (props) => {
  const customStyles = {
    control: (base, state) => ({
      ...base,
      overflow: "hidden",
      width: "140px",
      height: "20p",
      margin: "3px",
    }),
    dropdownContainer: (base, state) => ({
      ...base,
      gridTemplateRows: "0 min-content",
    }),
  };
  const frmRef = useRef({});
  const [employeeData, setEmployeeData] = useState([]);
  const [employeeId, setEmployeeId] = useState();
  const [unitsData, setUnitsData] = useState();
  const [itemSubType, setItemSubType] = useState();
  const [products, setProducts] = useState();
  const [productQuantity, setProductQuantity] = useState("");

  const [selectedSubType, setSelectedSubType] = useState();
  const [selectedUnit, setSelectedUnit] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState();
  const [selectionSubType, setSelectionSubType] = useState([]);
  const [selectionProduct, setSelectionProduct] = useState([]);
  const [selectionUnit, setSelectionUnit] = useState([]);
  const [filterProducts, setFilterProducts] = useState();
  const [editingProduct, setEditingProduct] = useState(null);

  const [minimumQtyText, setminimumQtyText] = useState(
    "Minimum Notifier Quantity"
  );
  const [unitId, setUnitId] = useState([]);
  const [unitList, setUnitList] = useState([]);
  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().substr(0, 10)
  );

  const [cropId, setCropId] = useState([]);
  const [cropList, setCropList] = useState([]);

  const handleDateChange = (e) => {
    setSelectedDate(e.target.value);
  };

  const currentDate = new Date().toISOString().slice(0, 10);
  // const productRef = useRef({});

  const [productDetails, setProductDetails] = useState([]);
  const [close, setClose] = useState(false);

  const customModalStyles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: 1000,
    },
    content: {
      top: "55%",
      left: "55%",
      transform: "translate(-50%, -50%)",
      maxWidth: "80%",
      width: "800px", // Adjust the width as needed
      height: "80%",
      minHeight: "500px",
      overflow: "auto",
    },
  };

  const [isModalOpen, setIsModalOpen] = useState(false);

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const { sendRequest: getEmp } = useHttp();

  useEffect(() => {
    getEmp(
      {
        url: `/api/employeeByUsecase/?orgId=${localStorage.getItem(
          "orgId"
        )}&useCase=Procurement`,
      },
      (data) => {
        //console.log(data);
        var emplist = data.output;

        setEmployeeData(emplist);
      }
    );
  }, []);

  const { sendRequest: getunits } = useHttp();

  useEffect(() => {
    getunits(
      {
        url: `/api/units?orgId=${localStorage.getItem("orgId")}`,
      },
      (res) => {
        if (res) {
          setUnitsData(res);
        }
      }
    );
  }, [getunits]);

  const { sendRequest: getSubItem } = useHttp();

  useEffect(() => {
    getSubItem(
      {
        url: `/api/productsubitem/?orgId=${localStorage.getItem(
          "orgId"
        )}&&createdBy=${localStorage.getItem("id")}`,
      },
      (res) => {
        if (res) {
          setItemSubType(res);
        }
      }
    );
  }, [getSubItem]);

  useEffect(() => {
    setSelectionSubType(
      itemSubType &&
        itemSubType.map((x) => ({
          value: x.productSubTypeId,
          label: x.productTypeName + " " + x.productSubTypeName,
        }))
    );
  }, [itemSubType]);

  const { sendRequest: getProducts } = useHttp();

  useEffect(() => {
    getProducts(
      {
        url: `/api/product/?orgId=${localStorage.getItem(
          "orgId"
        )}&&createdBy=${localStorage.getItem("id")}`,
      },
      (res) => {
        if (res) {
          setProducts(res);
        }
      }
    );
  }, [getProducts]);

  const { sendRequest: getUnit } = useHttp();

  const getUnitDetail = () => {
    getUnit(
      {
        url: `/api/units?orgId=${localStorage.getItem("orgId")}`,
      },
      (res) => {
        if (res) {
          var unit = res.filter(
            (item) =>
              item.unitTypeId == unitConstModel.NumberUnitTypeId ||
              item.unitTypeId == unitConstModel.weightUnitTypeId ||
              item.unitTypeId == unitConstModel.volumnUnitTypeId
          );
          setUnitList(unit);
        }
      }
    );
  };

  useEffect(() => {
    getUnitDetail();
  }, [getUnit]);

  const handleSubTypeChange = (option) => {
    setSelectedSubType(option);
    setSelectedProduct([]);
    setSelectedUnit([]);
  };

  useEffect(
    (e) => {
      const filteredProData =
        products &&
        products.filter(
          (item) =>
            parseInt(item.productSubTypeId) ===
            parseInt(selectedSubType && selectedSubType.value)
        );

      setFilterProducts(filteredProData);

      setSelectionProduct(
        filteredProData &&
          filteredProData.map((x) => ({
            value: x.productId,
            label: x.productName,
          }))
      );
    },
    [selectedSubType]
  );

  const handleProdcutChange = (option) => {
    if (option) {
      setSelectedProduct(option);
      setSelectedUnit([]);
    }
  };

  useEffect(
    (e) => {
      if (selectedProduct && selectedProduct.value) {
        
        const selectedProductData =
          products &&
          products.find(
            (item) =>
              parseInt(item.productId) === parseInt(selectedProduct.value)
          );

        if (selectedProductData) {
          const id = selectedProductData.unitId;

          const filteredUnits =
            unitsData &&
            unitsData
              .filter((item) => parseInt(item.unitId) === parseInt(id))
              .map((item) => item.unitTypeId);

          const TypeId = (filteredUnits && filteredUnits[0]) || 0;

          const uData =
            unitsData &&
            unitsData.filter(
              (item) => parseInt(item.unitTypeId) === parseInt(TypeId)
            );
          
          setSelectionUnit(
            uData &&
              uData.map((x) => ({
                value: x.unitId,
                label: x.unitName,
              }))
          );
        }
      }
    },
    [selectedProduct, products, unitsData]
  );

  const handleUnitChange = (option) => {
    setSelectedUnit(option);
  };

  // const submitProduct = (e) => {
  //   e.preventDefault();
  //   const productName = selectedProduct && selectedProduct.label;
  //   const itemSubTypeName = selectedSubType && selectedSubType.label;
  //   const quantity = productQuantity;
  //   const unit = selectedUnit && selectedUnit.label;

  //   if (!productName || !itemSubTypeName || !quantity || !unit) {
  //     toast.success("Please fill in all fields!");

  //     return;
  //   } else {
  //     const productName = selectedProduct && selectedProduct.label;
  //     const isDuplicate = productDetails.some(
  //       (product) => product.productName === productName
  //     );
  //     if (isDuplicate) {
  //       toast.success("Item already exists!");

  //       return;
  //     }
  //     setProductDetails((x) => [
  //       ...x,
  //       {
  //         productRequestDetailId: generateUniqueID(),
  //         productId: selectedProduct && selectedProduct.value,
  //         productName: selectedProduct && selectedProduct.label,
  //         productSubTypeName: selectedSubType && selectedSubType.label,
  //         productSubTypeId: selectedSubType && selectedSubType.value,
  //         quantity: quantity || 0,
  //         // quantityBalance: quantity || 0,
  //         unitId: selectedUnit && selectedUnit.value,
  //         unitName: selectedUnit && selectedUnit.label,
  //       },
  //     ]);

  //     setSelectedUnit({});
  //     setProductQuantity("");
  //     setSelectedProduct({});
  //     setSelectedSubType({});
  //     // productRef.current.quantity.value = 0;
  //   }
  // };

  // 👇 Add this state at top of component

  const submitProduct = (e) => {
    e.preventDefault();

    const productName = selectedProduct && selectedProduct.label;
    const itemSubTypeName = selectedSubType && selectedSubType.label;
    const quantity = productQuantity;
    const unit = selectedUnit && selectedUnit.label;

    if (!productName || !itemSubTypeName || !quantity || !unit) {
      toast.error("Please fill in all fields!");
      return;
    }

    if (editingProduct) {
      setProductDetails((prev) =>
        prev.map((p) =>
          p.productRequestDetailId === editingProduct.productRequestDetailId
            ? {
                ...p,
                productId: selectedProduct.value,
                productName: selectedProduct.label,
                productSubTypeName: selectedSubType.label,
                productSubTypeId: selectedSubType.value,
                quantity: quantity || 0,
                unitId: selectedUnit.value,
                unitName: selectedUnit.label,
              }
            : p
        )
      );
      toast.success("Product updated!");
      setEditingProduct(null);
    } else {
      const isDuplicate = productDetails.some(
        (product) => product.productName === productName
      );
      if (isDuplicate) {
        toast.error("Item already exists!");
        return;
      }

      setProductDetails((prev) => [
        ...prev,
        {
          productRequestDetailId: generateUniqueID(),
          productId: selectedProduct.value,
          productName: selectedProduct.label,
          productSubTypeName: selectedSubType.label,
          productSubTypeId: selectedSubType.value,
          quantity: quantity || 0,
          unitId: selectedUnit.value,
          unitName: selectedUnit.label,
        },
      ]);
      toast.success("Product added!");
    }

    setSelectedSubType(null);
    setSelectedProduct(null);
    setProductQuantity("");
    setSelectedUnit(null);
    setIsModalOpen(false);
  };

  const handleDelete = (index, e) => {
    setProductDetails(productDetails.filter((v, i) => i !== index));
  };

  function generateUniqueID() {
    const currentDateTime = new Date();
    const uniqueID =
      currentDateTime.getTime() + Math.floor(Math.random() * 1000);
    return uniqueID.toString();
  }

  const { sendRequest: postProductRequest } = useHttp();

  const submitHandler = (e) => {
    e.preventDefault();

    const data = {
      mediaRegistrationDate: moment(
        frmRef.current.mediaRegistrationDate.value
      ).format("DD/MM/YYYY"),
      mediaName: frmRef.current.mediaName.value,
      lifespan: frmRef.current.lifespan.value,
      quantity: frmRef.current.quantity.value,
      fieldExecutiveId: employeeId,
      unitId: unitId,

      description: frmRef.current.description.value,
      mediaRegistrationProductDetails: productDetails,
      createdBy: parseInt(localStorage.getItem("id")),
      orgId: parseInt(localStorage.getItem("orgId")),
      serviceId:props.sId,
    };

    if (props.update) {
      data["mediaRegistrationId"] = props.update.mediaRegistrationId;
    }

    console.log(data);

    postProductRequest(
      {
        url: "/api/mediaRegistration/",
        method: props.update ? "PUT" : "POST",
        body: data,
      },
      (data) => {
        //console.log(data);

        toast.success(
          `Media Registration ${props.update ? "Updated" : "Added"}`
        );
        props.addForm(false);
      },
      (error) => {
        toast.error("Media Name already exists.");
        console.error("Error saving media registration:", error);
      }
    );
  };

  const { sendRequest: getProductsForUpdate } = useHttp();

  useEffect(() => {
    if (props.update) {
      // console.log(props.update);

      frmRef.current.mediaRegistrationDate.value = moment(
        props.update.mediaRegistrationDate,
        "DD/MM/YYYY"
      ).format("YYYY-MM-DD");
      frmRef.current.mediaName.value = props.update.mediaName;
      frmRef.current.lifespan.value = props.update.lifespan;
      frmRef.current.quantity.value = props.update.quantity;
      setEmployeeId(props.update.fieldExecutiveId);
      setUnitId(props.update.unitId);

      const Id = props.update.mediaRegistrationId || 0;
      if (Id) {
        getProductsForUpdate(
          {
            url: `/api/mediaRegistration/?mediaRegistrationId=${Id}&orgId=${localStorage.getItem(
              "orgId"
            )}`,
          },
          (data) => {
            console.log(data);

            let ProData = data.mediaRegistrationDetails;

            setProductDetails(
              ProData &&
                ProData.map((detail) => ({
                  productRequestDetailId:
                    detail.productRequestDetailId || generateUniqueID(),
                  MediaRegistrationId: detail.MediaRegistrationId,
                  productId: detail.productId,
                  productName: detail.productName,
                  productSubTypeName: detail.productSubTypeName,
                  productSubTypeId: detail.productSubType,
                  quantity: detail.quantity,
                  unitId: detail.unitId,
                  unitName: detail.unitName,
                }))
            );
          }
        );
      }

      frmRef.current.description.value = props.update.description;
    }
  }, [props.update]);

  return (
    <>
      <div className="content-wrapper">
        <section className="content">
          <div className="container-fluid">
            <div className="card card-default">
              <form onSubmit={submitHandler}>
                <div className="card-header">
                  <h3 className="card-title">Media Registration Form</h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                <div className="card-body">
                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"date"}>
                        {"Media Registration Date"}
                      </label>
                      <input
                        type={"date"}
                        id={"mediaRegistrationDate"}
                        required
                        ref={(el) =>
                          (frmRef.current["mediaRegistrationDate"] = el)
                        }
                        className="form-control"
                        min={props.update ?? currentDate}
                      />
                    </div>

                    <div className="col-md-3">
                      <label htmlFor={"executive_name"}>
                        {"Field Executive"}
                      </label>
                      <select
                        id="emp_id"
                        className="form-control"
                        ref={(el) => (frmRef.current["emp_id"] = el)}
                        value={employeeId}
                        required
                        onChange={(e) => {
                          setEmployeeId(e.target.value);
                        }}
                      >
                        <option>Select</option>
                        {employeeData &&
                          employeeData.map((x) => (
                            <option key={x.userId} value={x.empId}>
                              {x.employeeName}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="col-md-3">
                      <label>Media Name</label>

                      <input
                        id="mediaName"
                        name="mediaName"
                        ref={(el) => (frmRef.current["mediaName"] = el)}
                        className="form-control"
                        required
                      />
                    </div>
                    <div className="col-md-3">
                      <label>Lifespan</label>

                      <input
                        type="number"
                        id="lifespan"
                        name="lifespan"
                        ref={(el) => (frmRef.current["lifespan"] = el)}
                        className="form-control"
                        required
                      />
                    </div>
                  </div>

                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label>Quantity</label>
                      <input
                        id="quantity"
                        name="quantity"
                        ref={(el) => (frmRef.current["quantity"] = el)}
                        className="form-control"
                        required
                      />
                    </div>
                    <div className="col-md-3">
                      <div className="form-group">
                        <label> Unit </label>

                        <select
                          id="unitId"
                          className="form-control"
                          ref={(el) => (frmRef.current["unitId"] = el)}
                          value={unitId}
                          required
                          onChange={(e) => {
                            const unitName =
                              e.target.options[e.target.selectedIndex].text;
                            const unitId = e.target.value;
                            setminimumQtyText(
                              "Minimum Notifier Quantity (" + unitName + ")"
                            );
                            setUnitId(unitId);
                            setSelectedUnit({
                              value: unitId,
                              label: unitName,
                            });
                          }}
                        >
                          <option value="">Select Unit</option>
                          {unitList &&
                            unitList.map((x) => (
                              <option
                                key={x.unitId}
                                unit-id={x.unitId}
                                value={x.unitId}
                              >
                                {x.unitAbbreviation}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"product_details"}>
                        {"Product Details"}
                      </label>
                      <br /> &nbsp; &nbsp; &nbsp; &nbsp;
                      <button
                        type="button"
                        id={"product_details"}
                        onClick={() => setIsModalOpen(true)}
                        ref={(el) => (frmRef.current["product_details"] = el)}
                        className="btn btn-sm btn-success"
                      >
                        Add
                      </button>
                    </div>

                    <div className="col-md-3">
                      <label htmlFor={"description"}>{"Description"}</label>
                      <input
                        type={"text"}
                        id={"description"}
                        required
                        ref={(el) => (frmRef.current["description"] = el)}
                        className="form-control"
                      />
                    </div>
                  </div>
                  <hr />
                  <table className="table table-bordered table-responsivetext-center">
                    <thead>
                      <tr>
                        <th>Sr. No</th>
                        <th>Product Sub Type</th>
                        <th>Product Name</th>
                        <th>Quantity</th>
                        <th>Unit</th>
                        <th>Edit</th>
                        <th>Delete</th>
                      </tr>
                    </thead>
                    <tbody>
                      {productDetails &&
                        productDetails.map((itm, i) => {
                          return (
                            <tr key={itm.productRequestDetailId}>
                              <td>{i + 1}</td>
                              <td>{itm.productSubTypeName}</td>
                              <td>{itm.productName}</td>
                              <td>{itm.quantity}</td>
                              <td>{itm.unitName}</td>
                              <td>
                                <button
                                  type="button"
                                  className="btn"
                                  onClick={() => {
                                    setEditingProduct(itm);
                                    setSelectedSubType(
                                      selectionSubType.find(
                                        (opt) =>
                                          opt.value === itm.productSubTypeId
                                      ) || {
                                        value: itm.productSubTypeId,
                                        label: itm.productSubTypeName,
                                      }
                                    );
                                    setSelectedProduct(
                                      itm.productId
                                        ? {
                                            value: itm.productId,
                                            label: itm.productName,
                                          }
                                        : null
                                    );
                                    setProductQuantity(itm.quantity || "");
                                    setSelectedUnit(
                                      itm && itm.unitId
                                        ? {
                                            value: itm.unitId,
                                            label: itm.unitName,
                                          }
                                        : null
                                    );

                                    setIsModalOpen(true);
                                  }}
                                >
                                  <i className="fas fa-edit"></i>
                                </button>
                              </td>

                              <td>
                                <button
                                  className="btn"
                                  onClick={(e) => handleDelete(i, e)}
                                >
                                  <i className="fas fa-trash"></i>
                                </button>
                              </td>
                            </tr>
                          );
                        })}
                    </tbody>
                  </table>
                  <hr />
                  <div className=" text-right">
                    <button type="submit" className="btn btn-primary">
                      Submit
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </section>
      </div>

      {isModalOpen && (
        <Modal isOpen={isModalOpen} style={customModalStyles}>
          <div className="">
            <h3 className="card-title">Product Details</h3>
            <div className="card-tools text-right">
              <button
                type="button"
                className="btn btn-tool"
                data-card-widget="remove"
                onClick={() => setIsModalOpen(false)}
              >
                <i className="fas fa-times" />
              </button>
              <hr />
            </div>
          </div>

          <div className="row mt-2">
            <div className="col-md-3">
              <label htmlFor={"itemType"}>Product Sub Type</label>

              <Select
                styles={customStyles}
                options={selectionSubType}
                value={selectedSubType}
                onChange={(option) => {
                  handleSubTypeChange(option);
                }}
                required
              />
            </div>
            <div className="col-md-3">
              <label htmlFor={"itemCategory"}>Product Name</label>

              <Select
                styles={customStyles}
                options={selectionProduct}
                value={selectedProduct}
                onChange={(option) => {
                  handleProdcutChange(option);
                }}
                required
              />
            </div>

            <div className="col-md-2">
              <label htmlFor={"itemDescription"}>Quantity</label>&nbsp;
              <input
                type="number"
                id="quantity"
                required
                value={productQuantity}
                onChange={(e) => setProductQuantity(e.target.value)}
                className="form-control"
              />
            </div>

            <div className="col-md-4">
              <div className="form-group">
                <label> Unit </label>

                <Select
                  styles={customStyles}
                  options={selectionUnit}
                  value={selectedUnit}
                  onChange={(option) => {
                    handleUnitChange(option);
                  }}
                  required
                />
              </div>
            </div>
          </div>
          <hr />

          <div className="text-center">
            <button
              className="btn btn-sm btn-primary"
              onClick={(e) => {
                submitProduct(e);
                setIsModalOpen(false);
              }}
            >
              Save
            </button>
          </div>
        </Modal>
      )}
    </>
  );
};

export default MediaRegistrationForm;
